import { useCallback, useEffect, useRef } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
export function useResizeObserver(observerCallback, elementRef) {
    const callback = useCallback(observerCallback, [observerCallback]);
    const observer = useRef(new ResizeObserver(callback));
    useEffect(() => {
        const currentElement = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const currentObserver = observer === null || observer === void 0 ? void 0 : observer.current;
        if (currentElement)
            currentObserver.observe(currentElement);
        return () => {
            if (currentElement)
                currentObserver.unobserve(currentElement);
        };
    }, [elementRef]);
    return observer === null || observer === void 0 ? void 0 : observer.current;
}
